import {
  background,
  flex,
  margin,
  padding,
  spacing,
  screen,
} from '@ebh/capsule/theme';

export default {
  container: [
    flex('row', 'justify-between', 'items-center'),
    background('primary-400'),
    padding(5, 'left'),
    {
      height: '8vh',
      position: 'sticky' as const,
      top: 0,
      width: '100%',
      zIndex: 10,
    },
    screen('md', padding(5, 'x')),
  ],
  logo: [
    {
      width: spacing(40),
      objectFit: 'contain' as const,
      display: 'block',
      alignItems: 'center',
      cursor: 'pointer',
    },
    padding(2, 'bottom'),
    margin(0, 'left'),
    screen('md', margin(10, 'left')),
  ]
};
